import type { PartNode } from '@partful/shared-types';
import { NamedLink } from './partNavigation';

const filterProductOptionsFromParents = (parents: NamedLink[]) => parents.filter(isProductOption);
const isProductOption = ({ data }: NamedLink) => data?.objectType !== 'product-option';

export const getParentBreadcrumbs = (parents: NamedLink[]) => {
  const parentsWithoutProductOptions = filterProductOptionsFromParents(parents);
  const parentBreadcrumbs = parentsWithoutProductOptions.filter((_, i) => {
    const hasProductOptionAsParent =
      i && parentsWithoutProductOptions[i - 1].data?.children[0]?.objectType === 'product-option';
    const isLastParentAnOption =
      i === parentsWithoutProductOptions.length - 1 &&
      parentsWithoutProductOptions[parentsWithoutProductOptions.length - 1].data?.children[0].objectType ===
        'product-option';

    if (hasProductOptionAsParent || isLastParentAnOption) {
      return false;
    }
    return true;
  });

  return parentBreadcrumbs;
};

export const getCurrentBreadcrumb = (parents: NamedLink[], current: PartNode | undefined) => {
  const breadcrumbsParents = filterProductOptionsFromParents(parents);
  const lastParent = breadcrumbsParents[breadcrumbsParents.length - 1]?.data?.children[0];
  const currentBreadcrumb =
    lastParent?.objectType === 'product-option' ? breadcrumbsParents[breadcrumbsParents.length - 1] : current;

  return currentBreadcrumb;
};
